const whereFunction = (itemField, field, itemDoc) => {
    let next = true;
    let validate;

    for (let i = 0; i < itemField.where.length; i++) {
        if (itemField.where[i].field !== null && itemField.where[i].field !== undefined) {
            for (let y = 0; y < itemField.where[i].field.length; y++) {
                if (next === true) {

                    let idField = itemField.where[i].field[y].idField;

                    if (itemField.where[i].field[y].idField.split('_').length === 1)
                        idField = `${itemDoc.entityDocId}_${itemDoc.id}_${itemField.where[i].field[y].idField}`;

                    if ((field[idField] !== null && field[idField] !== undefined) || field[idField] === 0) {
                        validate = false;
                        for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {
                            if (itemField.where[i].field[y].id[d] !== null) {
                                if (itemField.where[i].field[y].operator === 'in') {
                                    if (typeof field[idField] === 'object') {
                                        if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                            validate = true;
                                        }
                                    } else {
                                        if (field[idField].toString() === itemField.where[i].field[y].id[d].toString()) {
                                            validate = true;
                                        }
                                    }
                                }

                                if (itemField.where[i].field[y].operator === 'not in') {

                                    if (typeof field[idField] === 'object') {
                                        if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                            validate = false;
                                            break;
                                        } else {
                                            validate = true;
                                        }
                                    } else {
                                        if (field[idField].toString() === itemField.where[i].field[y].id[d].toString()) {
                                            validate = false;
                                            break;
                                        } else {
                                            validate = true;
                                        }
                                    }
                                }
                            }
                        }
                        if (validate === false) {
                            next = false;
                        }

                    } else {
                        validate = false;
                        next = false;
                    }
                }
            }

        }
    }
    return validate;
}

const whereFunctionHeader = (item, entity) => {

    if (Number(item.entityDocId) === 1 || Number(item.entityDocId) === 2)
        return true;
    if (item.onlyAttachment === true)
        return false;

    let existe = false;
    if (item.where !== null) {
        item.where.forEach((itemWhere) => {
            if (itemWhere.field !== null) {
                itemWhere.field.forEach((itemField, index) => {
                    if (index === 0 || existe === true) {
                        let fieldProd = itemField.name.split('.')[1];
                        
                        entity.forEach(entityItem => {
                            entityItem.boxes.forEach(box => {
                                box.fields.forEach(field => {
                                    if (field.idFieldTable === fieldProd && field.value !== null) {
                                        let value = field.value;
                                        let existeFlag = checkFieldValue(itemField, value);
                                        existe = existeFlag ? true : existe;
                                    }
                                });
                            });
                        });
                    }
                })
            }
        })
    } else {
        return true;
    }
    if (existe === true) {
        return existe;
    }
    return existe;
}

const checkFieldValue = (itemField, value) => {
    let existeFlag = false;
    itemField.id.forEach((itemIdField) => {
        if (itemField.operator === 'in') {
            if (typeof value === 'object') {
                if (Number(value.id) === Number(itemIdField)) {
                    existeFlag = true;
                }
            } else {
                if (value === itemIdField) {
                    existeFlag = true;
                }
            }
        }

        if (itemField.operator === 'not in') {
            if (typeof value === 'object') {
                if (Number(value.id) !== Number(itemIdField)) {
                    existeFlag = true;
                }
            } else {
                if (value !== itemIdField) {
                    existeFlag = true;
                }
            }
        }
    });
    return existeFlag;
}

const whereFunctions = {
    whereFunction,
    whereFunctionHeader
}
export default whereFunctions;